import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import AppLayout from "./components/AppLayout";
import ModuleGate from "./components/ModuleGate";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import HealthCheck from "./pages/HealthCheck";
import Reports from "./pages/Reports";
import ReportIssue from "./pages/ReportIssue";
import Actions from "./pages/Actions";
import AIAssistant from "./pages/AIAssistant";
import Resources from "./pages/Resources";
import Marketplace from "./pages/Marketplace";
import Sites from "./pages/Sites";
import Team from "./pages/Team";
import Analytics from "./pages/Analytics";
import ISO from "./pages/ISO";
import Training from "./pages/Training";
import ESG from "./pages/ESG";
import Contractors from "./pages/Contractors";
import Clients from "./pages/Clients";
import SuperUsers from "./pages/SuperUsers";
import MarketplaceCatalog from "./pages/MarketplaceCatalog";
import ServiceRequests from "./pages/ServiceRequests";
import GroupOperations from "./pages/GroupOperations";
import QRReport from "./pages/QRReport";

const gate = (mod, el) => <ModuleGate module={mod}>{el}</ModuleGate>;

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Navigate to="/app" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/report/:token" element={<QRReport />} />
            <Route path="/app" element={<AppLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="group" element={<GroupOperations />} />
              <Route path="health" element={<HealthCheck />} />
              <Route path="report" element={gate("report", <ReportIssue />)} />
              <Route path="reports" element={gate("reports", <Reports />)} />
              <Route path="actions" element={gate("actions", <Actions />)} />
              <Route path="assistant" element={gate("assistant", <AIAssistant />)} />
              <Route path="resources" element={gate("resources", <Resources />)} />
              <Route path="marketplace" element={gate("marketplace", <Marketplace />)} />
              <Route path="analytics" element={gate("analytics", <Analytics />)} />
              <Route path="iso" element={gate("iso", <ISO />)} />
              <Route path="training" element={gate("training", <Training />)} />
              <Route path="esg" element={gate("esg", <ESG />)} />
              <Route path="contractors" element={gate("contractors", <Contractors />)} />
              <Route path="sites" element={<Sites />} />
              <Route path="team" element={<Team />} />
              <Route path="clients" element={<Clients />} />
              <Route path="super-users" element={<SuperUsers />} />
              <Route path="catalog" element={<MarketplaceCatalog />} />
              <Route path="requests" element={<ServiceRequests />} />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
